import Bugsnag from "@bugsnag/js";
import { bugsnagPrivacyOptions } from "../src/shared/bugsnagPrivacy";
import initLocationFilterMultiSelects from "./locations/initLocationFilterMultiSelects";

Bugsnag.start({
  ...bugsnagPrivacyOptions,
  apiKey: window.AppConfig.BUGSNAG_FRONTEND_API_KEY || "invalid",
  releaseStage: window.AppConfig.RAILS_ENV,
  enabledReleaseStages: ["production", "staging"],
});

document.addEventListener("turbo:before-stream-render", (event) => {
  const defaultActions = event.detail.render;

  event.detail.render = (streamElement) => {
    defaultActions(streamElement);
    initLocationFilterMultiSelects();
  };
});

window.addEventListener("pageshow", (_event) => {
  initLocationFilterMultiSelects();
});

document.addEventListener("turbo:load", () => {
  initLocationFilterMultiSelects();
});
